import { ImportConfigurationRepository } from '../data/import-configuration-repository';
import { SheetMappingListResponse } from '../types/import-configuration-types';

/**
 * Use case for getting all sheet mappings
 */
export class GetSheetMappingsUseCase {
  constructor(private readonly repository: ImportConfigurationRepository) {}

  async execute(): Promise<SheetMappingListResponse> {
    return this.repository.getSheetMappings();
  }
}
